import { sortBy } from 'es-toolkit';

import { parseNullableValue } from '@hrlogics/helper-utils';

import { PeoPayrollProviderEmployersByIdQuery } from 'src/api';

import { LiveStatusSubject } from './constants';
import { PeoPayrollProviderLiveStatusValues } from './types';

export const prepareInitialDataForLiveStatus = (
  peoPayrollProvider: PeoPayrollProviderEmployersByIdQuery['peoPayrollProvider'],
) => {
  const peoEmployers =
    peoPayrollProvider?.peosList.map(peo => ({
      id: peo.id,
      displayName: parseNullableValue(peo.displayName),
      logo: peo.logo?.downloadUrl,
      subject: LiveStatusSubject.peo,
      isLive: peo.employersList.every(employer => !!employer.setLiveAt),
      employers: peo.employersList.map(employer => ({
        id: employer.id,
        displayName: parseNullableValue(employer.displayName),
        logo: employer.logo?.downloadUrl,
        isLive: !!employer.setLiveAt,
      })),
    })) ?? [];

  const peoPayrollProviderEmployers =
    peoPayrollProvider?.employersList.map(employer => ({
      id: employer.id,
      displayName: parseNullableValue(employer.displayName),
      logo: employer.logo?.downloadUrl,
      isLive: !!employer.setLiveAt,
      subject: LiveStatusSubject.employer,
    })) ?? [];

  return {
    isAllLive:
      peoEmployers.every(peo => peo.isLive) &&
      peoPayrollProviderEmployers.every(employer => employer.isLive) &&
      (!!peoEmployers.length || !!peoPayrollProviderEmployers.length),
    employers: sortBy(
      [...peoEmployers, ...peoPayrollProviderEmployers],
      [employer => employer.displayName],
    ),
  };
};

export const prepareUpdateData = (values: PeoPayrollProviderLiveStatusValues) => {
  const live: string[] = [];
  const notLive: string[] = [];

  values.employers.forEach(item => {
    if (item.subject === LiveStatusSubject.peo) {
      item.employers?.forEach(employer => {
        if (employer.isLive) live.push(employer.id);
        else notLive.push(employer.id);
      });
    } else if (item.isLive) live.push(item.id);
    else notLive.push(item.id);
  });

  return {
    live,
    notLive,
  };
};
